import React from "react";

const Footer = () => {
  const footerStyle = {
    width: "100%",
    height: "50px",
    backgroundColor: "orange",
    boxShadow: "0 0 10px rgba(0,0,0,.3)",
    textAlign: "center",
    color: "#EEEEEE"
  };

  const titleStyle = {
    fontWeight: "bold",
    fontSize: "1.2rem",
    lineHeight: "1.3",
    paddingTop: "10px"
  };

  const linkStyle = {
    textDecoration: "none",
    color: "white"
  };
  return (
    <div style={footerStyle}>
      <p style={titleStyle}>
        &copy;{" "}
        <a style={linkStyle} href="https://twitter.com/macha3k/">
          m.taira
        </a>
      </p>
    </div>
  );
};

export default Footer;
